import { Stack } from '@mui/material';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { ExportMenu } from '@retail/calculus/components';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { ContainedButton } from '@shared/components';
import dayjs from 'dayjs';
import { MutableRefObject } from 'react';

interface Props {
  apiRef: MutableRefObject<GridApiPremium | null>;
  openAddPricesDialog?: () => void;
}

export function FixedPriceToolbar({ apiRef, openAddPricesDialog }: Props) {
  const t = useCalculusTFunction();

  return (
    <Stack flexDirection="row" gap={1} alignItems="center" justifyContent="flex-end">
      <ExportMenu
        exportDataAsCsv={() =>
          apiRef.current?.exportDataAsCsv({
            utf8WithBom: true,
            fileName: `${t('calculus.localPriceSuggestions')}-${dayjs().format('YYYY-MM-DD')}`,
          })
        }
        exportDataAsExcel={() =>
          apiRef.current?.exportDataAsExcel({
            fileName: `${t('calculus.localPriceSuggestions')}-${dayjs().format('YYYY-MM-DD')}`,
          })
        }
      />
      {openAddPricesDialog && (
        <ContainedButton size="small" color="secondary" onClick={openAddPricesDialog}>
          {t('calculus.actions.addPrices')}
        </ContainedButton>
      )}
    </Stack>
  );
}
